export default {
    topics: [
        {
            title: ' ComputeAggregate ',
            href: 'sm-olapCube-ComputeAggregate.html',
            attributes: { 'data-id': 'sm-olapCube-ComputeAggregate' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-ComputeAggregate-d66e843',
            topics: [],
        },
        {
            title: ' CountListExport ',
            href: 'sm-olapCube-CountListExport.html',
            attributes: { 'data-id': 'sm-olapCube-CountListExport' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-CountListExport-d66e851',
            topics: [],
        },
        {
            title: ' CreateExportList ',
            href: 'sm-olapCube-CreateExportList.html',
            attributes: { 'data-id': 'sm-olapCube-CreateExportList' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-CreateExportList-d66e859',
            topics: [],
        },
        {
            title: ' GetAggregateSchema ',
            href: 'sm-olapCube-GetAggregateSchema.html',
            attributes: { 'data-id': 'sm-olapCube-GetAggregateSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetAggregateSchema-d66e867',
            topics: [],
        },
        {
            title: ' GetCubeSchema ',
            href: 'sm-olapCube-GetCubeSchema.html',
            attributes: { 'data-id': 'sm-olapCube-GetCubeSchema' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetCubeSchema-d66e875',
            topics: [],
        },
        {
            title: ' GetExportPossibilities ',
            href: 'sm-olapCube-GetExportPossibilities.html',
            attributes: { 'data-id': 'sm-olapCube-GetExportPossibilities' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetExportPossibilities-d66e883',
            topics: [],
        },
        {
            title: ' GetLinkLevels ',
            href: 'sm-olapCube-GetLinkLevels.html',
            attributes: { 'data-id': 'sm-olapCube-GetLinkLevels' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetLinkLevels-d66e891',
            topics: [],
        },
        {
            title: ' GetPivotData ',
            href: 'sm-olapCube-GetPivotData.html',
            attributes: { 'data-id': 'sm-olapCube-GetPivotData' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetPivotData-d66e899',
            topics: [],
        },
        {
            title: ' GetQuantiles ',
            href: 'sm-olapCube-GetQuantiles.html',
            attributes: { 'data-id': 'sm-olapCube-GetQuantiles' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetQuantiles-d66e907',
            topics: [],
        },
        {
            title: ' GetReportData ',
            href: 'sm-olapCube-GetReportData.html',
            attributes: { 'data-id': 'sm-olapCube-GetReportData' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetReportData-d66e915',
            topics: [],
        },
        {
            title: ' GetTopN ',
            href: 'sm-olapCube-GetTopN.html',
            attributes: { 'data-id': 'sm-olapCube-GetTopN' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-GetTopN-d66e924',
            topics: [],
        },
        {
            title: ' InvalidAggregates ',
            href: 'sm-olapCube-InvalidAggregates.html',
            attributes: { 'data-id': 'sm-olapCube-InvalidAggregates' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-InvalidAggregates-d66e932',
            topics: [],
        },
        {
            title: ' LoadCube ',
            href: 'sm-olapCube-LoadCube.html',
            attributes: { 'data-id': 'sm-olapCube-LoadCube' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-LoadCube-d66e940',
            topics: [],
        },
        {
            title: ' PrepareListExport ',
            href: 'sm-olapCube-PrepareListExport.html',
            attributes: { 'data-id': 'sm-olapCube-PrepareListExport' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-PrepareListExport-d66e948',
            topics: [],
        },
        {
            title: ' UpdateBinningClass ',
            href: 'sm-olapCube-UpdateBinningClass.html',
            attributes: { 'data-id': 'sm-olapCube-UpdateBinningClass' },
            menu: { hasChildren: false },
            tocID: 'sm-olapCube-UpdateBinningClass-d66e956',
            topics: [],
        },
    ],
};

